export default "__VITE_ASSET__33045219__"